<template>
  <div class="page">
    <ion-grid>
      <ion-row class="row-divider"></ion-row>
      <ion-row class="rectangle" v-if="vehicles && vehicles.length > 0">
        <ion-col>
          <ion-row align-items-stretch>
            <ion-col size-md="12"
              size-sm="12"
              size-xs="12"
              size-lg="12"
              size-xl="4" v-for="(vehicle, index) in this.vehicles" :key="index">
              <ion-card @click="viewVehicle(vehicle.id)">
                <ion-card-content class="vh-content">
                  <ion-row>
                    <ion-col text-left size="7">
                      <span class="vh-name">
                        <img
                          v-if="vehicle.type.id === 'TW'"
                          class="vh-icon"
                          src="/assets/images/vehicles/335024.png"
                        />
                        <img
                          v-if="vehicle.type.id == 'FW'"
                          class="vh-icon"
                          src="/assets/images/vehicles/846338.png"
                        />
                        <img
                          v-if="vehicle.type.id == '3W'"
                          class="vh-icon"
                          src="/assets/images/vehicles/rickshaw.png"
                        />
                        <img
                          v-if="vehicle.type.id == 'BUS'"
                          class="vh-icon"
                          src="/assets/images/vehicles/bus.png"
                        />
                        <img
                          v-if="vehicle.type.id == 'TRUCK'"
                          class="vh-icon"
                          src="/assets/images/vehicles/truck.png"
                        />
                          {{vehicle.regNo}}
                      </span>
                      <br />
                      <ion-label class="vh-model">{{vehicle.make.name}}&nbsp;{{vehicle.model.name}}</ion-label>
                      <br />
                      <!-- SCMT 2.0 Migration start -->
                      <!-- <ion-label class="vh-charge">{{vehicle.socketType.name}}</ion-label> -->
                       <!-- SCMT 2.0 Migration end -->
                    </ion-col>
                    <ion-col text-right size="5" class="ion-text-right">
                      <span class="vh-book-status"></span>
                        <ion-label
                          class="vh-book"
                          v-if="vehicle.bookingsMade > 0"
                        >{{vehicle.bookingsMade}} Booking(s)</ion-label>
                        <ion-label v-if="vehicle.bookingsMade <= 0" class="vh-book">&nbsp;</ion-label>
                        <br />
                        <br />
                        <!-- SCMT 2.0 Migration start -->
                        <!-- <ion-label class="vh-charge">{{vehicle.yearOfManufacturing}}</ion-label> -->
                         <!-- SCMT 2.0 Migration end -->
                    </ion-col>
                  </ion-row>
                </ion-card-content>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col text-left>
          <ion-fab vertical="bottom" horizontal="end">
            <ion-fab-button class="fab-primary" @click="addVehicle">
              Add Evs
              <!-- <ion-icon :icon="add"></ion-icon> -->
            </ion-fab-button>
          </ion-fab>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="spinner">
      <ion-spinner v-if="loaderTab"></ion-spinner>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonLabel, IonFab, IonFabButton, IonSpinner,IonIcon } from "@ionic/vue";
import { add } from 'ionicons/icons';

import { VehicleService } from "../../service/vehicle/vehicle.service";
import { ToastUtils } from "../../util/toast-utils";
import { LocalStorage } from "../../data/localstorage";
import { migratedTryParseServiceError } from "../../service";
import { Vehicle } from "../../entity/vehicle/vehicle";
import { User } from "../../entity/authentication/user";

export default defineComponent ({
  name: 'eVehicles',
  components: {
    IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonLabel, IonFab, IonFabButton, IonSpinner, IonIcon
  },
  data() {
    return {
      add,
      vehicles: null,
      loaderTab: true
    }
  },
  async mounted() {
    try {
      let user = new LocalStorage().user;
      let vehicles = await new VehicleService().vehiclesOfUser(user);
      if (vehicles && vehicles.length > 0) {
      this.vehicles = vehicles;
      }
      this.loaderTab = false;
    } catch(error) {
      this.loaderTab = false;
      // new ToastUtils().presentToast(error.response.data.errors[0].detail);
      let serviceError = migratedTryParseServiceError(error);
      new ToastUtils().presentToast(serviceError.description);
    }
    
  },
  methods: {
    addVehicle() {
      // this.$router.push("/customer/evehicles/vehicle");
      this.$router.push({
        name: "eVehicleNew",
        params: { vehicleType: "R" }
      });
    },
    viewVehicle(vehicleId) {
      this.$router.push({
        name: "eVehicleView",
        params: { vehicleId: vehicleId }
      });
    }
  }
})
</script>


<style scoped>
.rectangle {
padding: 0px !important;
}
ion-card {
/* height: 84px; */
box-shadow: 0px 3px 6px #00000029;
border-radius: 16px;
opacity: 1;
cursor: pointer;
}
ion-label-xxx {
text-align: left;
font-family: "Roboto Medium";
font-size: 15px;
letter-spacing: 0;
color: #313131;
opacity: 1;
display: inline-block;
vertical-align: middle;
}
.vh-name {
display: inline-block;
vertical-align: middle;
text-align: left;
font-family: "Roboto Medium";
font-size: 14px;
letter-spacing: 0;
color: #313131;
opacity: 1;
}
.vh-icon {
height: 17px;
width: 33px;
vertical-align: middle;
display: inline-block;
clear: left;
}
.vh-model {
text-align: left;
font-family: "Roboto";
font-size: 15px;
letter-spacing: 0;
color: #313131;
opacity: 0.75;
}
.vh-book {
text-align: left;
font-family: "Roboto Light";
font-size: 13px;
letter-spacing: 0;
color: #313131;
opacity: 0.75;
}
.vh-book-status {
width: 12px;
height: 11px;
background: #21b24b 0% 0% no-repeat padding-box;
border-radius: 36px;
opacity: 1;
}
.vh-charge {
text-align: left;
font-family: "Roboto Light";
font-size: 15px;
letter-spacing: 0;
color: #313131;
opacity: 0.75;
}
.vh-content {
padding: 10px;
background: #ffffff 0% 0% no-repeat padding-box;
box-shadow: 0px 3px 6px #00000029;
border-radius: 16px;
opacity: 1;
}
</style>